import React from "react";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import DashboardAppointmentsView from "../../DashboardAppointmentsView";
import { APPLICABLE_ROLE } from "../../DashboardAppointmentsView/Constant";
import DoctorCardComponent from "./DoctorCardComponent";
import NextAppointmentWidget from "./next-appointment-widget";

const StaffDashboardLeftContent = (props) => {
  const {
    handleRatingPopup,
    callNextAppointmentWidget,
    handleEndCall,
    clinicDropDownStatus,
  } = props;
  let user_type = localStorage.getItem("user_type");
  let clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);

  return (
    <div>
      <div className="container-fluid p-0 mobile-view">
        <div className="row">
          <div className="col-sm-12 col-lg-6 col-12 mb-4 mobile-view-doctor-card">
            <DoctorCardComponent />
          </div>
        </div>
      </div>
      {user_type === APPLICABLE_ROLE.DOCTOR && window.innerWidth < 798 && (
        <div className="col-sm-12 col-lg-6 col-12 doctor_card_view">
          <NextAppointmentWidget
            clinicId={clinicId}
            handleRatingPopup={handleRatingPopup}
            handleEndCall={handleEndCall}
          />
        </div>
      )}
      <DashboardAppointmentsView
        callNextAppointmentWidget={callNextAppointmentWidget}
        clinicDropDownStatus={clinicDropDownStatus}
      />
    </div>
  );
};

export default StaffDashboardLeftContent;
